import { Navigate } from "react-router-dom";

// Legacy /privacy → canonical /legal/privacy. The full Privacy Policy
// lives at /app/frontend/src/pages/legal/PrivacyPolicy.jsx.
export default function Privacy() {
  return <Navigate to="/legal/privacy" replace />;
}
